import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { AppState } from "../../../../app.state";
import { select, Store } from "@ngrx/store";
import {
  consultarDespachos,
  ejeccionAccionDespachoSuccess,
  terminarTemaDespacho,
  terminarTemaDespachoSuccess,
  updateCurrentDespacho,
  updateStatusDespacho,
} from "../../../../states/despacho/actions";
import {
  selectUserFormaEnvio,
  selectUsuario,
} from "../../../../states/usuario/selector";
import {
  ITerminarTemaDespacho,
  ITerminarTemaDespachoNotificacion,
} from "../../../../interfaces/acuerdos";
import { Subscription, take } from "rxjs";
import { AcuerdosService } from "../../../../services/acuerdos/acuerdos.service";
import { ConfirmDialogComponent } from "../../../../confirm-dialog/confirm-dialog.component";
import { LoadingService } from "../../../../loading/loading.service";
import { IDespacho } from "../../../../interfaces/despacho";

@Component({
  selector: "app-terminar-tema",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: "./terminar-tema.component.html",
  styleUrl: "./terminar-tema.component.css",
})
export class TerminarTemaComponent {
  //private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  private usuario: any = null;
  private formaEnvio: any = null;
  private stateUserSubscription!: Subscription;
  constructor(
    public loadingService: LoadingService,
    public acuerdosService: AcuerdosService,
    public dialogRef: MatDialogRef<TerminarTemaComponent>,
    public dialog: MatDialog,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit(): void {
    this.stateUserSubscription = this.store
      .pipe(select(selectUserFormaEnvio), take(1))
      .subscribe((stateUser) => {
        this.usuario = structuredClone(stateUser.usuario);
        this.formaEnvio = structuredClone(stateUser.formaEnvio);
      });
  }

  ngOnDestroy() {
    if (this.stateUserSubscription) {
      this.stateUserSubscription.unsubscribe();
    }
  }
  async terminarTemaDespacho() {
    this.loadingService.show();
    this.dialogRef.close();

    const temaDespacho: ITerminarTemaDespacho = {
      id_tema: this.data.id_tema,
      justificacionTema: "",
      id_usuario: this.usuario.uid,
      usuario: this.usuario.nombre,
    };

    const temaTerminado: ITerminarTemaDespachoNotificacion = {
      nombreUsuario: this.usuario.nombre,
      empresa: this.data.nombre_empresa,
      tipoDespacho: this.data.descripcion,
      nombreTema: this.data.nombreTema,
      descripcionTema: this.data.descripcionTema,
      id_empresa: this.data.id_empresa,
      notificacion: "temaTerminado",
    };

    if (this.usuario && this.formaEnvio) {
      try {
        const terminarTema = await this.acuerdosService.terminarTemaDespacho(
          temaDespacho
        );
        const notificarTema =
          await this.acuerdosService.notificacionTerminarTema(temaTerminado);

        if (!terminarTema.error && !notificarTema.error) {
          this.loadingService.hide();
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "450px",
            data: {
              title: "Éxito",
              message: "El tema ha sido terminado",
              showButtons: {
                accept: true,
                cancel: false,
              },
              direction: "end",
              buttonsName: {
                cancel: "CANCELAR",
                accept: "CERRAR",
              },
            },
          });

          dialogRef.componentInstance.confirmAction.subscribe(() => {
            this.loadingService.hide();
            this.store.dispatch(ejeccionAccionDespachoSuccess());
            const despacho: IDespacho = {
              expanded: true,
              ...this.formaEnvio.despacho,
            };
            this.usuario = null;
            this.formaEnvio = null;
            this.store.dispatch(updateCurrentDespacho({ despacho }));
            this.store.dispatch(updateStatusDespacho({ status: "terminar" }));
            this.store.dispatch(consultarDespachos());
          });

          dialogRef.componentInstance.cancelAction.subscribe(() => {
            this.usuario = null;
            this.formaEnvio = null;
            this.store.dispatch(terminarTemaDespachoSuccess());
          });
        }
      } catch (error) {
        this.loadingService.hide();
      }

      // this.store.dispatch(
      //   terminarTemaDespacho({ temaDespacho, temaTerminado })
      // );
    }
  }
}
